import React, { MouseEventHandler } from 'react';

import { atom } from 'jotai';

import { ButtonVariant } from '@cfa/react-components';
import { Colors } from '@cfa/react-components/dist/cjs/internal/types';

export interface PathwayModalAtomState {
  bodyContent?: React.ReactNode;
  bodyText?: string;
  bodyTextColor?: string;
  className?: string;
  /**
   * Fully custom footer content rendered inside ScrollModalFooter.
   * When provided, replaces the default primary/secondary button pair.
   * The scroll-shadow behaviour is handled by PathwayModal automatically.
   */
  footerContent?: React.ReactNode;
  /**
   * Title string rendered at the top of the header. Required.
   * Pair with `headerContent` to add extra elements below the title
   * (e.g. a search bar).
   */
  headerTitle: string;
  headerContent?: React.ReactNode;
  isDisabled?: boolean;
  isError?: boolean;
  isLoading?: boolean;
  isOpen?: boolean;
  modalSize?: 'sm' | 'md' | 'lg' | 'xl';
  onClose?: () => void;
  overlayClassName?: string;
  overlayStyle?: React.CSSProperties;
  primaryButtonColor?: Colors;
  primaryButtonHandler?: MouseEventHandler<HTMLButtonElement>;
  primaryButtonTestId?: string;
  primaryButtonText?: string;
  primaryButtonVariant?: ButtonVariant;
  secondaryButtonColor?: Colors;
  secondaryButtonHandler?: MouseEventHandler<HTMLButtonElement>;
  secondaryButtonTestId?: string;
  secondaryButtonText?: string;
  showCloseButton?: boolean;
  stepKey?: string;
  /**
   * Internal: ID of the composer instance that last opened the modal.
   * Used to prevent closed instances from clobbering an open one.
   */
  _ownerId?: string;
}

export const pathwayModalInitialState: PathwayModalAtomState = {
  isOpen: false,
  headerTitle: '',
  primaryButtonText: '',
};

export const pathwayModalAtom = atom(pathwayModalInitialState);
